export default __webpack_public_path__ + "static/media/whats-happening.inline.517d0602.svg";